import useFetchChartData from '@hooks/useFetchChartData'
import {
  AnalyticsGraphDataBase,
  FetchUserAnalyticsGraphParams,
} from '@models/user/UserAnalyticsGraph'
import { fetchAnalyticsGraph } from '@services/AnalyticsGraph'
import { tuttiFruttiPalette } from '@utils/colors'
import { durationFormatter } from '@utils/durationFormatter'
import dayjs from 'dayjs'
import { Area, AreaChart, Tooltip, XAxis, YAxis } from 'recharts'
import { DateAxisTick, DurationFormatedAxisTick } from '../common/AxisTicks'
import BaseChart from '../common/BaseChart'
import CustomTooltip from '../common/CustomTooltip'
import { ChartCommonProps } from '../common/chartCommonProps'

const AverageSessionDurationPerUser = ({
  displayMode = 'full',
}: ChartCommonProps) => {
  const { data, isLoading, error } = useFetchChartData<
    FetchUserAnalyticsGraphParams,
    AnalyticsGraphDataBase
  >({
    entity: 'user',
    kind: 'average-session-duration-per-user',
    fetchFunction: fetchAnalyticsGraph,
  })

  return (
    <BaseChart
      title="Average session duration per user"
      help="Average duration of sessions per user over the selected time range."
      data={data}
      isLoading={isLoading}
      error={error}
      height={displayMode == 'compact' ? 60 : 350}
      displayOnlyChart={displayMode == 'compact'}
    >
      <AreaChart data={data}>
        {displayMode == 'full' && (
          <>
            <YAxis
              dataKey="count"
              tickLine={false}
              stroke={'#bbb'}
              width={40}
              tick={(props) => <DurationFormatedAxisTick {...props} />}
            />
            <XAxis
              dataKey="label"
              tickLine={false}
              stroke={'#bbb'}
              height={20}
              tick={(props) => <DateAxisTick {...props} />}
            />
          </>
        )}
        <Tooltip
          content={(props) => (
            <CustomTooltip
              type="bar"
              {...props}
              valueFormatter={(value) =>
                durationFormatter(Number(value)) || '0s'
              }
              customLabelFormatter={(payload) =>
                dayjs(payload.label).format('D MMM YY')
              }
            />
          )}
        />
        <Area
          dataKey="count"
          type="monotone"
          fill={displayMode == 'full' ? tuttiFruttiPalette[14] : 'transparent'}
          stroke={tuttiFruttiPalette[12]}
          strokeWidth={displayMode == 'full' ? 1 : 2}
        />
      </AreaChart>
    </BaseChart>
  )
}

export default AverageSessionDurationPerUser
